"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var StoreMeeting = function StoreMeeting(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 31 27"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(.906 .125)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: 10.977,
    y: 15.766,
    width: 7.374,
    height: 9.457,
    rx: 1
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 1.047,
    y: 7.411,
    width: 27.135,
    height: 17.789,
    rx: 2
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#ffffff",
    d: "M1.091 9.638h27.046V2.223a1 1 0 0 0-1-1H2.091a1 1 0 0 0-1 1v7.415z"
  }))));
};
var _default = exports.default = StoreMeeting;